var _rect, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 14.6667,
    fill: "#24A346"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.83203,
    y: 1.83325,
    width: 18.3333,
    height: 11,
    fill: "#82D9A3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.29167,
    cy: 2.29167,
    r: 2.29167,
    fill: "#24A346"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.29167,
    cy: 12.3749,
    r: 2.29167,
    fill: "#24A346"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.7096,
    cy: 2.29167,
    r: 2.29167,
    fill: "#24A346"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.7096,
    cy: 12.3749,
    r: 2.29167,
    fill: "#24A346"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 7.33325,
    r: 2.75,
    fill: "#24A346"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.4987,
    cy: 7.33341,
    r: 0.916667,
    fill: "#24A346"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4987,
    cy: 7.33341,
    r: 0.916667,
    fill: "#24A346"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cash.509d8968.svg";
export { ForwardRef as ReactComponent };